import { FC } from 'react';
import { useParams } from 'react-router-dom';
import NotFound from './notFound';
import PublicCallRecording from 'features/public-call-recordings/public-call-recording';

export const CallRecordingPage: FC = () => {
  const { siteId, hash } = useParams();
  const isPageValid = siteId !== undefined && hash !== undefined;

  return isPageValid ? (
    <div className="flex items-center justify-center h-screen">
      <div className="w-108">
        <PublicCallRecording siteId={siteId} hash={hash} />
      </div>
    </div>
  ) : (
    <NotFound />
  );
};
